import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-fire" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_popover = _resolveComponent("n-popover")!

  return ($props.NoRule || _ctx.IsEdit())
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_component_n_popover, {
          trigger: "hover",
          "show-arrow": false
        }, {
          trigger: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createTextVNode(" عرض التفاصيل ")
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}